import { render, staticRenderFns } from "./VenuesList.vue?vue&type=template&id=03cb7978"
import script from "./VenuesList.vue?vue&type=script&lang=js"
export * from "./VenuesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports